import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import React from 'react'
import './faq.scss'
import Arrow from './Arrow'




export default function Faq() {
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };


  return (
    <div className="faq">
      <div className="faq__fone1"></div>
      <div className="faq__container">
        <span className="span-text">
          FAQ
        </span>
        <Typography variant='h2'>
          Популярные вопросы
        </Typography>
        <div className="faq-acs">
          <Accordion className='faq-ac' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
            <AccordionSummary
              expandIcon={<Arrow />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className='faq-ac-sum'
            >
              <Typography className='faq-ac-sum__t'>Нужна ли мне защита, если я плачу за заявки, а не за клики?</Typography>
            </AccordionSummary>
            <AccordionDetails className='faq-ac-det'>
              <Typography className='faq-ac-det__t'>
              Да, потому что фейковые клики (от которых мы защищаем) увеличивают цену заявки.
              </Typography>
            </AccordionDetails>
          </Accordion >
          
		  
      <Accordion className='faq-ac' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
            <AccordionSummary
              expandIcon={<Arrow />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className='faq-ac-sum'
            >
              <Typography className='faq-ac-sum__t'>Поможет ли защита, если скликиватели будут использовать прокси для смены IP адреса?</Typography>
            </AccordionSummary>
            <AccordionDetails className='faq-ac-det'>
              <Typography className='faq-ac-det__t'>
              Да, чаще всего получается связать посетителей по fingerprint, yandex client id и другим параметрам.
              </Typography>
            </AccordionDetails>
          </Accordion >

		  
		 <Accordion className='faq-ac' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
            <AccordionSummary
              expandIcon={<Arrow />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className='faq-ac-sum'
            >
              <Typography className='faq-ac-sum__t'>Можно ли попробовать сервис бесплатно?</Typography>
            </AccordionSummary>
            <AccordionDetails className='faq-ac-det'>
              <Typography className='faq-ac-det__t'>
              Да, у нас есть бесплатная пробная версия на 7 дней. Если не увидите результата, вы ничем не рискуете.
              </Typography>
            </AccordionDetails>
          </Accordion >

		  <Accordion className='faq-ac' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
            <AccordionSummary
              expandIcon={<Arrow />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className='faq-ac-sum'
            >
              <Typography className='faq-ac-sum__t'>Почему меня скликивают?</Typography>
            </AccordionSummary>
            <AccordionDetails className='faq-ac-det'>
              <Typography className='faq-ac-det__t'>
              Это может происходить по разным причинам. Иногда вас скликивают конкуренты, чтобы у вас закончился рекламный бюджет и они забрали себе всех будущих клиентов. Иногда вашу рекламу скликивают боты создателя сайта, который монетизируется через РСЯ. В этом случае владелец площадки не атакует именно вас, а просто старается максимально монетизировать свой сайт. 
              </Typography>
            </AccordionDetails>
          </Accordion >
		  

        </div>
      </div>
      <div className="faq__fone2"></div>
    </div>
  )
}